import { createFileRoute } from '@tanstack/react-router'

import { AssetPricingPage } from '@/components/AssetPricingPage'

export const Route = createFileRoute('/_app/asset-pricing')({
  component: AssetPricingPageRoute,
})

function AssetPricingPageRoute() {
  return <AssetPricingPage />
}
